<template>
  <data-section
    theme="green"
    title="國泰產險-傷害險"
    :isHurtInsurance="true"
    :datas="
      _.orderBy(
        highlightModify,
        ['familyrl', 'age', 'ceisdno', 'orderbBySelf', 'ceplcno'],
        ['asc', 'desc', 'asc', 'asc', 'asc']
      )
    "
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 155,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc']
        },
        {
          name: '險種',
          key: 'cepln_nm',
          width: 200,
          sortable: true,
          orderByMultiKey: ['cepln_nm'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'ceapcnm',
          width: 80,
          sortable: true,
          orderByMultiKey: ['ceapcnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 80,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '出單日期',
          key: 'cepoldt',
          width: 96,
          sortable: true,
          orderByMultiKey: ['cepoldt'],
          orderByMultiType: ['asc']
        },
        {
          name: '有效期間',
          key: 'ceplcdt',
          width: 111,
          sortable: true,
          orderByMultiKey: ['celpsdt'],
          orderByMultiType: ['desc']
        },
        {
          name: '保費',
          key: 'premium1',
          width: 109,
          sortable: true,
          thClassName: 'text-right',
          className: 'text-right',
          orderByMultiKey: ['premium1'],
          orderByMultiType: ['asc']
        }
      ].concat(_fields)
    "
    @toggle="
      (isShow) =>
        $router.assignQuery({ CathayPropertyHurtInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayPropertyHurtInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayPropertyHurtInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayPropertyHurtInsuranceSort`]
            ? JSON.parse($route.query[`CathayPropertyHurtInsuranceSort`])
            : null
        "
      >
        <template slot="ceplcno" scope="item">
          <span :class="{ 'text-blue': item.data.isKeyinBySelf }">{{
            item.data.ceplcno
          }}</span>
        </template>
        <template slot="ceapcnm" scope="item">
          <span>
            {{ item.data.ceapcnm | truncate }}
          </span>
        </template>
        <template slot="ceisdnm" scope="item">
          <span @click="routeToCustDetail(item.data.ceisdno,item.data.ceisdnm )">
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="cepoldt" scope="item">
          {{ getROCDate(item.data.cepoldt) }}
        </template>
        <template slot="ceplcdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndString(
                getROCDate(item.data.ceplcdt) + ' ' + item.data.ceplcdt_time,
                getROCDate(item.data.celpsdt) + ' ' + item.data.celpsdt_time
              )
            "
          ></div>
        </template>
        <template slot="premium1" scope="item"
          >{{ item.data.premium1 | numberFormat }}元</template
        >
        <template slot="action" scope="item">
          <a
            role="button"
            class="text-red text-underline"
            @click="doDelete(item.data)"
            >刪除</a
          >
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { deleteSelfInputPropertyNumber } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  methods: {
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(`${data.ceplcno} ${data.cepln_nm}`)
      );
      await this.deleteSuccessHandler(
        deleteSelfInputPropertyNumber(
          this.$store.state.userInfo.id,
          data.ceplcno,
          ""
        )
      );
      this.isLoading = true;
      this.$bus.emit(
        "cathay-hurt-insurance.get",
        () => (this.isLoading = false)
      );
    }
  }
};
</script>
